import React, { useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Button,
  TablePagination,
  Paper,
  TextField,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  CircularProgress,
  Autocomplete,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import * as Action from "../../actions/adminAction";
import { BASE_URL } from "../../utils/urls";
import moment from "moment";

export const ConsolidatedTrainerList = ({
  getAllDistrictData,
  getAllTrainersRegional,
  getAllTrainers,
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loader, setLoader] = useState(false);

  //data variables
  const [city, setCity] = useState("");
  const [cityData, setcityData] = useState([]);
  const [cityError, setcityError] = useState(false);

  const [userData, setuserData] = useState([]);
  const [searchTrainerError, setsearchTrainerError] = useState(false);
  const [searchTrainer, setsearchTrainer] = useState(null);

  // Toggle state for Daily/Monthly
  const [reportType, setReportType] = useState("daily");

  // Month filter state - default to current month (YYYY-MM format)
  const [selectedMonth, setSelectedMonth] = useState(
    moment().format("YYYY-MM")
  );

  //Table Pagination variables
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  //Table Pagination Functions
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {

    getDistrict();
  }, []);

  useEffect(() => {
    if (searchTrainer) {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTrainer, city, reportType, selectedMonth]);

  const getDistrict = async () => {
    const result = await getAllDistrictData();
    if (result !== "No data found") {
      setcityData(result);
    }
  };

  const getTrainers = async () => {
    const result = await getAllTrainers();
    if (result) {
      setuserData(result);
    }
  };

  const fetchRegionalTrainers = async () => {
    try {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      // Fix: append array values properly
      ["trainer", "regional_coordinator"].forEach((type) => {
        urlencoded.append("userType", type);
      });

      let requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: urlencoded,
        redirect: "follow",
      };

      const response = await fetch(BASE_URL + "/user/getuserlist", requestOptions);
      const result = await response.json();

      // Safely extract the array
      if (Array.isArray(result)) {
        setuserData(result);
      } else if (result && Array.isArray(result.Data)) {
        setuserData(result.Data);
      } else if (result && Array.isArray(result.data)) {
        setuserData(result.data);
      } else {
        setuserData([]);
      }
    } catch (error) {
      console.error("Error fetching regional trainers:", error);
      setuserData([]);
    }
  };
  console.log(userData, "udd")
  const getData = async () => {
    setLoader(true);
    let payload = {
      trainer_id: searchTrainer ? searchTrainer._id : "",
      distric_id: city ? city._id : "",
      reportType: reportType,
      month: selectedMonth || "",
    };

    await fetch(
      BASE_URL + "/trainingassigntrainer/trainerDistrictWiseDocUplodCount",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }
    )
      .then((res) => res.json())
      .then((response) => {
        console.log(response);
        if (
          response &&
          response.success &&
          Array.isArray(response.data) &&
          response.data.length > 0
        ) {
          setData(response);
        } else {
          setData(null);
        }
        setLoader(false);
      })
      .catch((Err) => {
        console.log("Err while getting propertType", Err);
        setLoader(false);
      });
  };

  const handleReportTypeChange = (event, newReportType) => {
    if (newReportType !== null) {
      setReportType(newReportType);
      // Reset other filters when toggle changes, keep month as current
      setsearchTrainer(null);
      setCity("");
      setsearchTrainerError(false);
      setcityError(false);
      setSelectedMonth(moment().format("YYYY-MM"));
      setData(null);
      setPage(0);
    }
  };

  /**
   * Rows for the table — depends on reportType
   * DAILY: each item in `data.data` is a training row.
   * MONTHLY: each item in `data.data` is one aggregate with `trainingDetails[]`.
   *          We produce ONE row per grampanchayat aggregate.
   */
  const tableRows = useMemo(() => {
    if (!data || !Array.isArray(data.data) || data.data.length === 0) {
      return [];
    }

    // ---------------- DAILY ----------------
    if (reportType === "daily") {
      return data.data.map((row) => ({
        ...row,
        approvedTraining: 1,
      }));
    }

    // ---------------- MONTHLY ----------------
    // New response shape (per grampanchayat):
    // {
    //   totalAssignments, totalUploadCount, totalApprovedCount, totalRejectedCount,
    //   trainingDetails: [ { _id, trainer_id, trainer_idAll, trainerName,
    //                        trainerNameAll, trainingModule_id, trainingModuleName,
    //                        distric_id, districtName, grampanchayat_id,
    //                        grampanchayatName, docUploadedCount, docApprovedCount,
    //                        startDate, endDate, categoryType, createdAt, ... } ]
    // }
    const rows = [];

    data.data.forEach((gpAgg) => {
      const details = Array.isArray(gpAgg?.trainingDetails)
        ? gpAgg.trainingDetails
        : [];

      // Pick the first training as the representative for identity fields
      const first = details[0] || {};

      // Month label from selectedMonth (e.g. "October 2026")
      const monthLabel = moment(data.month, "YYYY-MM").format("MMMM YYYY");

      // Build the state object to send to FormFill / FormFillCombine.
      // Both components read via `state?.xxx`, so any missing key
      // gracefully falls back to undefined.
      const monthlyState = {
        // ---- Identity ----
        _id: first?._id,
        trainer_id: first?.trainer_id,
        trainerName:
          first?.trainerName ||
          `${searchTrainer?.firstName || ""} ${searchTrainer?.lastName || ""
            }`.trim(),
        trainer_idAll: first?.trainer_idAll || [],
        trainerNameAll: first?.trainerNameAll || [],
        trainerMobileAll: [],
        trainerCount: details.length,
        trainerSignature: [],

        // ---- Location ----
        distric_id: first?.distric_id,
        districtName:
          first?.districtName || city?.districtName || "-",
        grampanchayat_id: first?.grampanchayat_id,
        grampanchayatName: first?.grampanchayatName,
        taluka_id: first?.taluka_id,
        talukaName: first?.talukaName,

        // ---- Module (first as representative) ----
        trainingModule_id: first?.trainingModule_id,
        trainingModuleName: first?.trainingModuleName,
        categoryType: first?.categoryType,

        // ---- Dates / Month ----
        month: first?.month || moment(data.month, "YYYY-MM").format("MMMM"),
        startDate: first?.startDate,
        endDate: first?.endDate,
        fromDate: first?.startDate,
        toDate: first?.endDate,

        // ---- Aggregated counts ----
        docUploadedCount: gpAgg?.totalUploadCount || 0,
        docApprovedCount: gpAgg?.totalApprovedCount || 0,
        docRejectedCount: gpAgg?.totalRejectedCount || 0,

        // ---- ALL trainingDetails for SessionSubjectDetails ----
        trainingDetails: details,

        // ---- Safe defaults for fields not in monthly response ----
        typeOfDoc: [],
        typeOfDocStatus: [],
        isAssigned: false,
        isApprovedFinal: false,
        isRejectedFinal: false,
        totalBeneficiaryData: [],
        castBifircation: [],
        representative: [],
        feedbackformData: [],
        resultform: [],
        status: "new",
        isDelete: false,
        createdAt: first?.createdAt,
        updatedAt: first?.updatedAt,
        createdBy: first?.createdBy,
        updatedBy: first?.updatedBy,
        shift: first?.shift || "",
      };

      rows.push({
        _id: `${first?.grampanchayat_id || first?._id}_${data.month}`,

        // ---- Table display fields ----
        monthLabel,
        monthStartDate: moment(data.month, "YYYY-MM")
          .startOf("month")
          .toISOString(),
        trainerName:
          first?.trainerName ||
          `${searchTrainer?.firstName || ""} ${searchTrainer?.lastName || ""
            }`.trim(),
        districtName:
          first?.districtName || city?.districtName || "-",
        grampanchayatName: first?.grampanchayatName || "-",
        trainingModuleName:
          first?.trainingModuleName ||
          (details.length > 1 ? `${details.length} Modules` : "-"),
        docUploadedCount: gpAgg?.totalUploadCount || 0,
        docApprovedCount: gpAgg?.totalApprovedCount || 0,
        approvedTraining:
          details.length || gpAgg?.totalAssignments || 0,
        isMonthlyAggregate: true,

        // ---- Rich state for FormFill / FormFillCombine ----
        _monthlyState: monthlyState,

        rawGrampanchayat: gpAgg,
      });
    });

    return rows;
  }, [data, reportType, searchTrainer, city]);

  // Total approved training across all rows
  const totalApprovedTraining = useMemo(
    () =>
      tableRows.reduce((sum, r) => sum + (r?.approvedTraining || 0), 0),
    [tableRows]
  );

  const handleGenerateReport = (row) => {
    if (reportType === "daily") {
      // ---- DAILY ----
      navigate(`/admin/generateDaily`, {
        state: {
          reportType: "daily",
          selectedMonth,
          trainer: searchTrainer,
          district: city,
          ...row, // the specific row clicked (spreads API fields)
          apiResponse: data,
          tableRows,
          totalApprovedTraining,
        },
      });
      return;
    }

    // ---- MONTHLY ----
    const monthlyState = row?._monthlyState || {};

    navigate(`/admin/FormFill`, {
      state: {
        reportType: "monthly",
        selectedMonth,
        trainer: searchTrainer,
        district: city,

        // Rich single-training-document state
        ...monthlyState,

        // Extra meta (kept, in case the target page uses them)
        apiResponse: data,
        tableRows,
        totalApprovedTraining,
      },
    });
  };


  useEffect(() => {
    if (reportType === "monthly") {

      fetchRegionalTrainers()
    } else {
      getTrainers()
    }


  }, [reportType])

  return (
    <div className={classes.main}>
      <center>
        <Typography style={{ margin: 20, fontSize: 30, fontWeight: 600 }}>
          Consolidated Trainer wise Report
        </Typography>
      </center>

      {/* Toggle for Daily/Monthly */}
      <div style={{ marginBottom: 20 }}>
        <ToggleButtonGroup
          value={reportType}
          exclusive
          onChange={handleReportTypeChange}
          aria-label="report type"
          sx={{
            "& .MuiToggleButton-root": {
              px: 4,
              py: 1,
              fontWeight: 600,
              textTransform: "none",
            },
            "& .Mui-selected": {
              backgroundColor: "#1976d2 !important",
              color: "white !important",
            },
          }}
        >
          <ToggleButton value="daily">Daily</ToggleButton>
          <ToggleButton value="monthly">Monthly</ToggleButton>
        </ToggleButtonGroup>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          marginTop: 20,
          marginBottom: 30,
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 10,
        }}
      >
        <Autocomplete
          id="Trainer-data"
          sx={{ width: 300 }}
          options={userData}
          autoHighlight
          disablePortal
          freeSolo
          disabled={userData === undefined || userData.length === 0}
          getOptionLabel={(option) =>
            option?.firstName +
            " " +
            option?.lastName +
            " - " +
            option?.contactNo
          }
          renderInput={(params) => (
            <TextField {...params} label={`${reportType === "monthly" ? "Search By Trainer & Regional Coordinator" : "Search By Trainer"} `} />
          )}
          value={searchTrainer}
          onChange={(event, newValue) => setsearchTrainer(newValue)}
        />
        {searchTrainerError ? (
          <span style={{ color: "red" }}>*Please Select trainer first</span>
        ) : null}

        {searchTrainer ? (
          <FormControl sx={{ m: 1, marginRight: 1 }}>
            <InputLabel id="outlined-adornment-Bank">District</InputLabel>
            <Select
              style={{ width: 300 }}
              id="outlined-adornment-Bank"
              label="District"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              MenuProps={{ style: { maxHeight: 400 } }}
              disabled={cityData === undefined || cityData.length === 0}
            >
              {cityData &&
                cityData.map((item) => (
                  <MenuItem key={item?._id} value={item}>
                    {item?.districtName}
                  </MenuItem>
                ))}
            </Select>
            {cityError ? (
              <span style={{ color: "red", fontSize: 15 }}>
                *Please Select District
              </span>
            ) : null}
          </FormControl>
        ) : null}

        {/* Month Filter - Shown for both Daily and Monthly */}
        {searchTrainer ? (
          <TextField
            label="Select Month"
            type="month"
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{ width: 250, m: 1 }}
          />
        ) : null}
      </div>

      {!searchTrainer ? (
        <center>
          <Typography style={{ margin: 20, fontSize: 20, fontWeight: 600 }}>
            Please Select Trainer first to get Data.
          </Typography>
        </center>
      ) : loader ? (
        <center style={{ marginTop: 30 }}>
          <CircularProgress color="primary" />
        </center>
      ) : (
        <>
          <div className={classes.countDiv}>
            <Typography style={{ margin: 20, fontSize: 17, fontWeight: 600 }}>
              Total Training Assigned -{" "}
              {reportType === "monthly"
                ? data?.data?.[0]?.totalAssignments ?? data?.count ?? 0
                : data?.count ?? tableRows.length}
            </Typography>

            <Typography style={{ margin: 20, fontSize: 17, fontWeight: 600 }}>
              Total Document Upload -{" "}
              {reportType === "monthly"
                ? data?.data?.[0]?.totalUploadCount ?? 0
                : tableRows.reduce(
                  (s, r) => s + (r?.docUploadedCount || 0),
                  0
                )}
            </Typography>

            <Typography style={{ margin: 20, fontSize: 17, fontWeight: 600 }}>
              Total Approved Training - {totalApprovedTraining}
            </Typography>
          </div>
          <Paper sx={{ overflow: "hidden", width: "90%" }}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                      <strong>SR No.</strong>
                    </TableCell>
                    <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                      <strong>Trainer Name</strong>
                    </TableCell>
                    <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                      <strong>District</strong>
                    </TableCell>
                    <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                      <strong>School Name</strong>
                    </TableCell>
                    <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                      <strong>Training Module</strong>
                    </TableCell>
                    <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                      <strong>
                        {reportType === "monthly"
                          ? "Month"
                          : "Training Start Date"}
                      </strong>
                    </TableCell>
                    <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                      <strong>Documents Uploaded</strong>
                    </TableCell>
                    <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                      <strong>Documents Approved</strong>
                    </TableCell>
                    <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                      <strong>Approved Training</strong>
                    </TableCell>
                    <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                      <strong>Action</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableRows.length > 0 ? (
                    tableRows
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => {
                        return (
                          <TableRow key={row?._id || index}>
                            <TableCell
                              style={{ fontSize: 16, textAlign: "center" }}
                            >
                              {index + 1 + rowsPerPage * page}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: 16, textAlign: "center" }}
                            >
                              {row?.trainerName ||
                                searchTrainer?.firstName +
                                " " +
                                searchTrainer?.lastName}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: 16, textAlign: "center" }}
                            >
                              {row?.districtName}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: 16, textAlign: "center" }}
                            >
                              {row?.grampanchayatName}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: 16, textAlign: "center" }}
                            >
                              {row?.trainingModuleName}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: 16, textAlign: "center" }}
                            >
                              {reportType === "monthly"
                                ? row?.monthLabel
                                : moment(row?.startDate).format("DD MMM YYYY")}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: 16, textAlign: "center" }}
                            >
                              {row?.docUploadedCount}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: 16, textAlign: "center" }}
                            >
                              {row?.docApprovedCount}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: 16, textAlign: "center" }}
                            >
                              {row?.approvedTraining}
                            </TableCell>
                            <TableCell
                              style={{ fontSize: 16, textAlign: "center" }}
                            >
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={() => handleGenerateReport(row)}
                                sx={{
                                  textTransform: "none",
                                  fontSize: 13,
                                }}
                              >
                                Generate Report
                              </Button>
                            </TableCell>
                          </TableRow>
                        );
                      })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={10} style={{ textAlign: "center" }}>
                        No data found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={tableRows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </>
      )}
    </div>
  );
};

const useStyles = makeStyles(() => ({
  main: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    marginTop: 30,
  },
  countDiv: {
    width: "90%",
    display: "flex",
    justifyContent: "space-between",
  },
}));

const mapStateToProps = (state) => ({
  userDetails: state.auth.userDetails,
  img1: state.admin.img1,
  img2: state.admin.img2,
});

const mapDispatchToProps = (dispatch) => ({
  getAllDistrictData: () => dispatch(Action.getAllDistrictData()),
  getDistrictWiseTalukaData: (data) =>
    dispatch(Action.getDistrictWiseTalukaData(data)),
  getTalukaWisePanchayat: (data) =>
    dispatch(Action.getTalukaWisePanchayat(data)),
  getAllTrainingModuleData: () => dispatch(Action.getAllTrainingModuleData()),
  FetchApprovedTrainingData: (data) =>
    dispatch(Action.FetchApprovedTrainingData(data)),
  FetchAllApprovedTrainingData: () =>
    dispatch(Action.FetchAllApprovedTrainingData()),
  fetchDateWiseApprovedTrainingData: (data) =>
    dispatch(Action.fetchDateWiseApprovedTrainingData(data)),
  getAllTrainers: () => dispatch(Action.getAllTrainers()),
  getAllTrainersRegional: () => dispatch(Action.getAllTrainersRegional()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConsolidatedTrainerList);